import PubSub from 'pubsub-js';

import { scrollTop } from '../utils';

const $html = $('html');

PubSub.subscribe('init', () => {
    $('.footer__menu').each((index, element) => {
        $(element).on('click', () => {
            const targetId = $('a', element).data('id');
            $html.removeClass('-fixed');
            PubSub.publish('top.updateBackground', targetId);
        });
    });

    $('.local-menuContent__link').each((_index, element) => {
        $(element).on('click', () => {
            const targetId = $( element).data('id');
            const target = $(`.content[data-id="${targetId}"]`);
            scrollTop(target.offset().top);
            $html.removeClass('-showMenu');
        });
    });
});